import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useRef } from 'react';
import { InputField } from '../../../../../components/formFields/InputField';
import Label from '@/components/Label';
import { AreaField } from '../../../../../components/formFields/AreaField';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';
import { useEffect } from 'react';
import { apiService } from '../../../../../utils/api';
import { useState } from 'react';

interface BuildingObjectModalProps {
  visible: boolean;
  title: string;
  formProps?: any;
  onSubmit: (id: any, values: any) => void;
  onClose: () => void;
  classification?: any[];
}

const BuildingObjectModal = ({
  visible,
  title,
  formProps,
  onSubmit,
  onClose,
}: BuildingObjectModalProps) => {
  const [buildingObjectTypes, setBuildingObjectTypes] = useState([]);
  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
    description: Yup.string().nullable().required('Povinné pole'),
    building_object_type: Yup.string().nullable().required('Povinné pole'),
    number: Yup.string().nullable().required('Povinné pole'),
  });

  const formRef = useRef(null);

  const onSubmitButton = () => {
    if (!formRef?.current) return null;
    (formRef.current as any).submitForm();
  };

  useEffect(() => {
    const fetchBOTypes = async () => {
      try {
        const response = await apiService.get('api/v1/building-object/types/');

        setBuildingObjectTypes(response.data);
      } catch (e) {
        console.log(e);
      }
    };
    fetchBOTypes();
  }, []);

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Formik
            innerRef={formRef}
            enableReinitialize={true}
            validationSchema={ValidationSchema}
            initialValues={{
              title: formProps?.title || null,
              description: formProps?.description || null,
              number: formProps?.number || null,
              building_object_type: formProps?.building_object_type || null,
            }}
            onSubmit={(values) => {
              onSubmit(formProps?.id, {
                ...values,
              });
            }}
          >
            {(props) => {
              const { values } = props;
              return (
                <>
                  <Form>
                    <div className="space-y-1">
                      <div>
                        <Label name="title" title="Název" required />
                        <Field
                          name="title"
                          value={values.title || null}
                          placeholder="Název"
                          component={InputField}
                          data-testid="building-object-modal-title-input"
                        />
                      </div>

                      <div>
                        <Label name="description" title="Plný popis" required />
                        <Field
                          name="description"
                          value={values.description || null}
                          placeholder="Plný popis"
                          component={AreaField}
                          data-testid="building-object-modal-description-input"
                        />
                      </div>

                      <div>
                        <Label name="number" title="Číslo" required />
                        <Field
                          name="number"
                          value={values.number || null}
                          placeholder="Číslo"
                          component={InputField}
                          data-testid="building-object-modal-number-input"
                        />
                      </div>

                      <div>
                        <Label
                          name="building_object_type"
                          title="Typ stavebního objektu"
                          required
                        />
                        <SelectFormField
                          name="building_object_type"
                          placeholder="..."
                          data-testid="building-object-modal-type-select"
                          data={(buildingObjectTypes || []).map((item: any) => ({
                            id: item.shortcut,
                            title: item.title,
                          }))}
                        />
                      </div>
                    </div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            data-testid="building-object-modal-close-btn"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button
            key={2}
            data-testid="building-object-modal-submit-btn"
            onClick={() => onSubmitButton()}
          >
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BuildingObjectModal;
